
import store_soins from '@/store/mods/clinique/soins'
import $ from 'jquery'

export default {
    name: 'l-chirurgie',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,
            all_checked: false,
            one_is_checked: [],
            each_cat_is_checked: [],
            liste_chirurgies: [],
        }
    },
    
    computed: {

    },

    mounted() {
        this.fetchChirurgies()
    },

    methods: {
        fetchChirurgies() {
            this.is_loading = true
            this.is_load_error = false

            store_soins.getListeChirurgies().then((response) => {
                this.liste_chirurgies = response
                this.is_empty = this.liste_chirurgies.length === 0
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        toutSelectionner() {
            const is_checked = $('#chirurgie-tous').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []

            if (is_checked) {
                this.liste_chirurgies.forEach((categorie_chirurgie) => {
                    this.each_cat_is_checked.push(categorie_chirurgie.chirurgie_id)
                    categorie_chirurgie.kchirurgies.forEach((kchr) => {
                        this.one_is_checked.push({id: kchr.id, libelle: kchr.k_chirurgie})
                    })
                })
            }

            this.all_checked = is_checked
        },

        touteCategorie(index) {
            const is_checked = $('#kchirurgie-tous'+index).is(":checked")
            this.toggleCategorieChecked(is_checked, index)
        },

        toggleCategorieChecked(is_checked, index) {
            this.liste_chirurgies.forEach((categorie_chirurgie) => {
                if (categorie_chirurgie.chirurgie_id == index) {
                    if (is_checked) {
                        // remove all chirurgies of this category from one_is_checked
                        this.one_is_checked = this.one_is_checked.filter((chirurgie) => {
                            return !categorie_chirurgie.kchirurgies.some((kchr) => kchr.id === chirurgie.id)
                        })
                    }

                    categorie_chirurgie.kchirurgies.forEach((kchr) => {
                        if (is_checked) {
                            this.one_is_checked.push({id: kchr.id, libelle: kchr.k_chirurgie})
                        } else {
                            this.one_is_checked = this.one_is_checked.filter((kchr) => {
                                return !categorie_chirurgie.kchirurgies.some((kc) => kc.id === kchr.id)
                            })
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },
    }
}